export default "__VITE_ASSET__CsafK_9I__"